import "core-js/modules/es.array.map";

var _Icon;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Text } from "../../Typography";
import Icon from '../Icon';
import styles from './ProfileMenu.scss';
var items = [{
  title: 'MENU_GENERAL_INFORMATION',
  slug: 'main'
}, {
  title: 'MENU_SECURITY',
  slug: 'security'
}];

function ProfileMenu(_ref) {
  var currentItem = _ref.currentItem,
      onChange = _ref.onChange;

  var _useTranslation = useTranslation('profile'),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement("div", {
    className: styles.menu
  }, items && items.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.slug,
      onClick: function onClick() {
        return onChange(item.slug);
      },
      className: classnames(styles.item, _defineProperty({}, styles.active, currentItem && currentItem === item.slug))
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.menuItemsWrap
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "div"
    }, t(item.title)), /*#__PURE__*/React.createElement("div", {
      className: styles.menuIcon
    }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
      name: "caret-right",
      color: "text"
    })))));
  }));
}

ProfileMenu.defaultProps = {
  currentItem: undefined
};
export default ProfileMenu;